export default "__VITE_ASSET__BX2YJBiM__"